import useNativeCurrency from '../../../../hooks/web3/useNativeCurrency';
import { TokenIcons } from '../../../../assets/icons';
import { EnabledChains, Tokens } from '../../../../config/constants';
import { formatUSD } from '../../../../helpers';
import Card from '../../../../components/Card';
import useUserBalance from '../../../../hooks/web3/useUserBalance';
import useTokenDetails from '../../../../hooks/web3/useTokenDetails';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../../../config/config';
import { formatUnits } from 'ethers/lib/utils';

const AccountBalance = () => {
    const { chainId } = useWeb3React();
    const { nativeCurrency } = useNativeCurrency();

    const { decimals } = useTokenDetails(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    const userBalance = useUserBalance(
        config.addresses[chainId as EnabledChains[number]]?.collateral
    );

    return (
        <div className='account-balance'>
            <Card className='native-currency-balance' variant='secondary'>
                <div className='title'>{nativeCurrency?.symbol} Balance</div>
                <div className='value'>
                    {nativeCurrency
                        ? formatUSD(nativeCurrency?.balance, {
                              currency: '',
                              maxDecimals: 4,
                          })
                        : '-'}{' '}
                    {nativeCurrency &&
                        TokenIcons[nativeCurrency?.symbol ?? Tokens.FALLBACK]}
                    {nativeCurrency && nativeCurrency.symbol}
                </div>
            </Card>
            <Card className='collateral-balance' variant='secondary'>
                <div className='title'>{Tokens.USDC} Balance</div>
                <div className='value'>
                    {userBalance
                        ? formatUSD(formatUnits(userBalance, decimals), {
                              currency: '',
                              maxDecimals: 4,
                          })
                        : '-'}{' '}
                    {TokenIcons[Tokens.USDC]}
                    {Tokens.USDC}
                </div>
            </Card>
        </div>
    );
};

export default AccountBalance;
